import { FC, ReactElement, useContext, useEffect, useRef } from 'react'
import { LanguageContext } from '../LanguageContext/LanguageContext'
import { getHtmlLanguage } from '../../utils/getHtmlLanguage'

interface IAppContainerProps {
  children: ReactElement
}

export const AppContainer: FC<IAppContainerProps> = ({ children }) => {
  const ref = useRef<HTMLDivElement>(null)
  const { language } = useContext(LanguageContext)

  useEffect(() => {
    const currentRef = ref.current

    const resizeObserver = new ResizeObserver(() => {
      const width = Math.max(
        document.documentElement.scrollWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth,
      )
      const height = Math.max(
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight,
        document.documentElement.clientHeight,
      )

      if (window.parent) {
        window.parent.postMessage(
          {
            isResize: true,
            contentSize: { width, height },
          },
          '*',
        )
      }
    })

    if (currentRef) {
      resizeObserver.observe(currentRef)
    }

    return () => {
      if (currentRef) {
        resizeObserver.disconnect()
      }
    }
  }, [])

  useEffect(() => {
    document.documentElement.lang = getHtmlLanguage(language)
  }, [language])

  return <div ref={ref}>{children}</div>
}
